import type { ICotizacion } from "./entidades/ICotizacion";
import type { IRespuestaApiLista, IRespuestaApiObjeto } from "../../globales/interfaces";
// import api from "../../utils/api";

export class CotizadorModelo {
    // 

    constructor() { }
    
    public async obtenerListaCotizaciones(): Promise<IRespuestaApiLista<ICotizacion>> {
        // TODO: Descomentar cuando el backend esté listo
        // const { data } = await api.get(
        //     `/api/Cotizaciones/Listar`, {
        //     headers: {
        //         "Content-Type": "application/json",
                
        //     },
        // });
        // return data;

        // Data quemada para desarrollo
        const dataQuemada: ICotizacion[] = [
            {
                Id: 1,
                IdSolicitud: 100,
                CodigoServicio: 1001,
                FechaCreacion: "2025-01-02T10:30:00Z",
                TecnicoSolicita: "Yesid Hurtado",
                Repuesto: "Tornillo",
                Cantidad: 1,
                PrecioVenta: 30000,
                FechaAprobacion: null,
                Aprobada: false,
                Eliminado: false,
                CreadoUtc: "2025-01-02T10:30:00Z",
                ActualizadoUtc: "2025-01-02T10:30:00Z"
            },
            {
                Id: 2,
                IdSolicitud: 101,
                CodigoServicio: 1002,
                FechaCreacion: "2025-01-10T14:15:00Z",
                TecnicoSolicita: "Yesid Hurtado",
                Repuesto: "Puerta",
                Cantidad: 4,
                PrecioVenta: 120000,
                FechaAprobacion: null,
                Aprobada: false,
                Eliminado: false,
                CreadoUtc: "2025-01-10T14:15:00Z",
                ActualizadoUtc: "2025-01-10T14:15:00Z"
            },
            {
                Id: 3,
                IdSolicitud: 102,
                CodigoServicio: 1003,
                FechaCreacion: "2025-01-15T09:45:00Z",
                TecnicoSolicita: "María González",
                Repuesto: "Motor",
                Cantidad: 1,
                PrecioVenta: 850000,
                FechaAprobacion: "2025-01-16T11:20:00Z",
                Aprobada: true,
                Eliminado: false,
                CreadoUtc: "2025-01-15T09:45:00Z",
                ActualizadoUtc: "2025-01-16T11:20:00Z"
            },
            {
                Id: 4,
                IdSolicitud: 103,
                CodigoServicio: 1004,
                FechaCreacion: "2025-01-18T16:30:00Z",
                TecnicoSolicita: "Carlos Rodríguez",
                Repuesto: "Cable eléctrico",
                Cantidad: 2,
                PrecioVenta: 45000,
                FechaAprobacion: null,
                Aprobada: false,
                Eliminado: false,
                CreadoUtc: "2025-01-18T16:30:00Z",
                ActualizadoUtc: "2025-01-18T16:30:00Z"
            },
            {
                Id: 5,
                IdSolicitud: 104,
                CodigoServicio: 1005,
                FechaCreacion: "2025-01-20T08:15:00Z",
                TecnicoSolicita: "Ana López",
                Repuesto: "Panel de control",
                Cantidad: 1,
                PrecioVenta: 320000,
                FechaAprobacion: null,
                Aprobada: false,
                Eliminado: false,
                CreadoUtc: "2025-01-20T08:15:00Z",
                ActualizadoUtc: "2025-01-20T08:15:00Z"
            },
            {
                Id: 6,
                IdSolicitud: 105,
                CodigoServicio: 1006,
                FechaCreacion: "2025-01-22T13:45:00Z",
                TecnicoSolicita: "Luis Martínez",
                Repuesto: "Sensores",
                Cantidad: 3,
                PrecioVenta: 180000,
                FechaAprobacion: "2025-01-23T10:30:00Z",
                Aprobada: true,
                Eliminado: false,
                CreadoUtc: "2025-01-22T13:45:00Z",
                ActualizadoUtc: "2025-01-23T10:30:00Z"
            }
        ];

        return {
            Data: dataQuemada,
            NotificationType: 1, // EnumTipoNotificacion.Success
            Messages: [],
            Pagination: {
                Total: dataQuemada.length,
                Page: 1,
                Size: 10,
                TotalPages: 1,
                HasNext: false,
                HasPrevious: false
            }
        };
    }

    public async aprobarCotizacion(cotizacion: ICotizacion): Promise<IRespuestaApiObjeto<ICotizacion>> {
        // TODO: Descomentar cuando el backend esté listo
        // const { data } = await api.put(
        //     `/api/Cotizaciones/Aprobar`, cotizacion, {
        //     headers: {
        //         "Content-Type": "application/json",
                
        //     },
        // });
        // return data;

        // Simulación de aprobación exitosa
        const cotizacionAprobada = {
            ...cotizacion,
            Aprobada: true,
            FechaAprobacion: new Date().toISOString(),
            ActualizadoUtc: new Date().toISOString()
        };

        return {
            Data: cotizacionAprobada,
            NotificationType: 1, // EnumTipoNotificacion.Success
            Messages: [`Cotización ${cotizacion.IdSolicitud} aprobada exitosamente`],
            Pagination: {
                Total: 1,
                Page: 1,
                Size: 1,
                TotalPages: 1,
                HasNext: false,
                HasPrevious: false
            }
        };
    }

    public async aprobarCotizacionesMasivas(cotizaciones: ICotizacion[]): Promise<IRespuestaApiObjeto<ICotizacion[]>> {
        // TODO: Descomentar cuando el backend esté listo
        // const { data } = await api.put(
        //     `/api/Cotizaciones/AprobarMasivas`, cotizaciones, {
        //     headers: {
        //         "Content-Type": "application/json",
                
        //     },
        // });
        // return data;

        // Simulación de aprobación masiva exitosa
        const cotizacionesAprobadas = cotizaciones.map(cotizacion => ({
            ...cotizacion,
            Aprobada: true,
            FechaAprobacion: new Date().toISOString(),
            ActualizadoUtc: new Date().toISOString()
        }));

        return {
            Data: cotizacionesAprobadas,
            NotificationType: 1, // EnumTipoNotificacion.Success
            Messages: [`${cotizaciones.length} cotización(es) aprobadas exitosamente`],
            Pagination: {
                Total: cotizaciones.length,
                Page: 1,
                Size: cotizaciones.length,
                TotalPages: 1,
                HasNext: false,
                HasPrevious: false
            }
        };
    }

        public async rechazarCotizacionesMasivas(cotizaciones: ICotizacion[]): Promise<IRespuestaApiObjeto<ICotizacion[]>> {
        // TODO: Descomentar cuando el backend esté listo
        // const { data } = await api.put(
        //     `/api/Cotizaciones/AprobarMasivas`, cotizaciones, {
        //     headers: {
        //         "Content-Type": "application/json",
                
        //     },
        // });
        // return data;

        // Simulación de aprobación masiva exitosa
        const cotizacionesAprobadas = cotizaciones.map(cotizacion => ({
            ...cotizacion,
            Aprobada: true,
            FechaAprobacion: new Date().toISOString(),
            ActualizadoUtc: new Date().toISOString()
        }));

        return {
            Data: cotizacionesAprobadas,
            NotificationType: 1, // EnumTipoNotificacion.Success
            Messages: [`${cotizaciones.length} cotización(es) aprobadas exitosamente`],
            Pagination: {
                Total: cotizaciones.length,
                Page: 1,
                Size: cotizaciones.length,
                TotalPages: 1,
                HasNext: false,
                HasPrevious: false
            }
        };
    }

    public async rechazarCotizacion(cotizacion: ICotizacion): Promise<IRespuestaApiObjeto<boolean>> {
        // TODO: Descomentar cuando el backend esté listo
        // const { data } = await api.put(
        //     `/api/Cotizaciones/Rechazar`, cotizacion, {
        //     headers: {
        //         "Content-Type": "application/json",
                
        //     },
        // });
        // return data;

        // Simulación de rechazo exitoso
        return {
            Data: true,
            NotificationType: 1, // EnumTipoNotificacion.Success
            Messages: [`Cotización ${cotizacion.IdSolicitud} rechazada exitosamente`],
            Pagination: {
                Total: 1,
                Page: 1,
                Size: 1,
                TotalPages: 1,
                HasNext: false,
                HasPrevious: false
            }
        };
    }
}

